import {
  Edit02Icon,
  Tick02Icon,
  Timer02Icon
} from '@hugeicons/react'
import clsx from 'clsx'

import { Card } from '@/shared/ui/Card'

import type { MissionShowStatus } from '../../constants/showStatus'
import { missionShowCardBodyClass, missionShowCardClass } from './showCard'

type MissionTimelineProps = {
  showStatus: MissionShowStatus
}

const STEPS = [
  {
    icon: Edit02Icon,
    tone: 'primary',
    title: 'Envie sua evidência',
    subtitle: 'Responda e envie'
  },
  {
    icon: Timer02Icon,
    tone: 'progress',
    title: 'Aguarde avaliação',
    subtitle: 'Equipe analisa'
  },
  {
    icon: Tick02Icon,
    tone: 'success',
    title: 'Receba recompensas',
    subtitle: 'Se aprovado, ganhe XP'
  }
] as const

const toneClass: Record<(typeof STEPS)[number]['tone'], string> = {
  primary: 'bg-brand-surface text-primary',
  progress: 'bg-orange-50 text-orange-600',
  success: 'bg-green-50 text-green-600'
}

const activeStepForStatus = (status: MissionShowStatus): number => {
  if (status === 'approved') return 3
  if (status === 'pending') return 2
  if (status === 'refused') return 1
  return 1
}

export const MissionTimeline = ({ showStatus }: MissionTimelineProps) => {
  const activeStep = activeStepForStatus(showStatus)

  return (
    <Card className={missionShowCardClass}>
      <Card.Body className={missionShowCardBodyClass}>
        <h2 className="m-0 text-sm font-bold text-gray-900">Como funciona?</h2>

        <div className="grid grid-cols-3 gap-2">
          {STEPS.map((step, index) => {
            const stepNumber = index + 1
            const isActive = stepNumber <= activeStep
            const Icon = step.icon

            return (
              <div
                key={step.title}
                className={clsx(
                  'flex flex-col items-center rounded-xl px-2 py-3 text-center',
                  isActive ? 'bg-[#fafafc]' : 'opacity-60'
                )}
              >
                <span
                  className={clsx(
                    'mb-2 flex h-9 w-9 items-center justify-center rounded-full',
                    toneClass[step.tone]
                  )}
                >
                  <Icon size={16} variant="duotone" aria-hidden />
                </span>
                <span className="text-2xs font-bold leading-snug text-gray-800">
                  {stepNumber}. {step.title}
                </span>
                <span className="mt-0.5 text-2xs leading-snug text-gray-700">
                  {step.subtitle}
                </span>
              </div>
            )
          })}
        </div>
      </Card.Body>
    </Card>
  )
}
